import { useCallback, useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { getOwnPortalUser } from '@idk-web/api';
import { portalUser, updateUser, type PortalUser } from '@/state/portalAuth';

export type User = PortalUser & {
  /**
   * Reloads the current user globally
   */
  reload(): Promise<void>;
};

/**
 * Returns the currently logged in portal user.
 *
 * This hook may only be used in components that are only mounted when a portal
 * user is guaranteed to be logged in.
 */
export function usePortalUser(): User {
  const user = useAtomValue(portalUser);

  const reload = useCallback(async () => {
    if (!user) {
      console.warn('Tried to reload user when user is missing in state');
      return;
    }

    const response = await getOwnPortalUser();

    updateUser(response);
  }, [user]);

  return useMemo(
    () => ({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ...user!,
      reload,
    }),
    [user, reload],
  );
}
